/**
 * Protocol Management Form Before Checkout
 */

(function( $ ) {
		$( document ).ready( function() {
			'use strict';

			$( '#adherences-before-cart-form .table-style input:checkbox' )
				.change( function() {
					adherenceOnlyOneRequiredCheckbox( $( this ) );
				} );

			$( '#adherences-select-all input:checkbox' ).change( function() {
				adherenceSelectAll( $( this ) );
			} );

			$( '#protocol-checkout' ).validator()
			                         .on( 'submit', function( e ) {
				                         if ( !e.isDefaultPrevented() ) {
					                         $( '[type=submit]', this )
						                         .attr( 'disabled', 'disabled' )
						                         .addClass( 'disabled' );
					                         $( '[type=submit]', this )
						                         .html( ' <img class="spinner" src="' + ISDA_Main.ajaxLoader + '">' );
				                         }

			                         } );

		} );

		/**
		 * @summary Only one checkbox required
		 *
		 * Once checkbox in an area has been checked, remove
		 * required attr from other checkboxes in that area.
		 * So long as the checkbox doesn't have the required override,
		 * remove required attr.
		 *
		 * @todo: Get this working with data attribute, not a class
		 */
		function adherenceOnlyOneRequiredCheckbox( checkbox ) {
			var thisCheckbox     = checkbox,
			    checkboxSiblings = thisCheckbox.closest( '.adh-data-row' )
			                                   .siblings( '.adh-data-row' )
			                                   .find( '.checkbox input:checkbox' );

			if ( thisCheckbox.is( ':checked' ) ) {
				checkboxSiblings.removeAttr( 'required', 'required' );
			} else {
				//check if siblings are checked
				if ( checkboxSiblings.is( ':checked' ) ) {
					checkboxSiblings.removeAttr( 'required', 'required' );
				} else {
					thisCheckbox.attr( 'required', 'required' );
					checkboxSiblings.attr( 'required', 'required' );
				}
			}

			$( '#adherences-before-cart-form' ).validator( 'validate' );
		}

		/**
		 * @summary Select all checkbox
		 *
		 * Checkbox to select/deselect all protocols in pending before checkout
		 *
		 * @param checkbox
		 */
		function adherenceSelectAll( checkbox ) {
			var thisCheckbox    = $( checkbox ),
			    tableCheckboxes = $( '#adherences-before-cart-form .table-style input:checkbox' );

			if ( thisCheckbox.is( ':checked' ) ) {
				tableCheckboxes.each( function() {
					$( this ).prop( 'checked', true );
					$( '#adherences-before-cart-form' ).validator( 'validate' );
				} );
			} else {
				tableCheckboxes.each( function() {
					$( this ).prop( 'checked', false );
					$( '#adherences-before-cart-form' ).validator( 'validate' );
				} );
			}
		}

	}
)( jQuery );